module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mf2AoD/images/cover.jpg?1684274265000",
      "alt": "This image is the cover for the book Last Rites"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Rites\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Last Rites chronicles one man's dramatic descent into the seedy world of New England mobster Raymond Patriarca and his underboss, Gennaro \"Jerry\" Angiulo. In the early 1980s, Gigi Portalla, a well-liked student, athlete and Revere prom king, transformed into a mafia hit man after discovering that his biological father was \"Big Eddy\" Marino. Portalla rose through the ranks within the Angiulo organization, joining famous Boston wise guys like Sean Cote, Joseph \"J.R.\" Russo and Bobby Carrozza. Drawing on wiretaps, court testimonies and interviews through personal relationships with the criminals in question, Revere writer William J. Craig uncovers the depths of criminality. Portalla clung to a self-imposed moral code, striving to find honor within thievery, even as the lure of his family's past eclipsed his promising future.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William J. Craig\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William J. Craig has served in the U.S. Army and U.S. Air Force. He graduated from Gordon College with a B.A. in history and currently resides with his wife and children in Revere, Massachusetts where he works as an author and speaker.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0